<panel width="400">
  <menu always-visible>
    <menuitem (click)="displayProduct()">{{ 'product.context-menu.create' | translate }}</menuitem>
  </menu>
  <h1>{{ 'product.list-products' | translate }}</h1>
  <h2>{{ 'product.active' | translate }}</h2>
  @if (!activeProducts) {
    <skeletons [defaultSkeletons]="4" />
  }
  @if (activeProducts) {
    <list-view [emptyLabel]="'product.products-list.products-list-empty-label'" scrollable>
      <header [hidden]="true" defaultSort="ascending">{{ 'product.column.name' | translate }}</header>
      <row *listData="let product from activeProducts" [highlighted]="selectedProductId == product.id" (action)="displayProduct(product.id)">
        <column>{{ product.name }}</column>
      </row>
    </list-view>
    }<br />
    <h2>{{ 'product.inactive' | translate }}</h2>
    @if (!inactiveProducts) {
      <skeletons [defaultSkeletons]="2" />
    }
    @if (inactiveProducts) {
      <list-view [emptyLabel]="'product.products-list.products-list-empty-label'" scrollable>
        <header [hidden]="true" defaultSort="ascending">{{ 'product.column.name' | translate }}</header>
        <row *listData="let product from inactiveProducts" [highlighted]="selectedProductId == product.id" (action)="displayProduct(product.id)">
          <column>{{ product.name }}</column>
        </row>
      </list-view>
    }
  </panel>
